export default {
  userLogged: state => state.userLogged,
  user: state => state.user,
  users: state => state.users,
  usersSearch: state => state.usersSearch,
  userNotifications: state => state.userNotifications,
  userLoggedIsOwnerOfBudget: state => state.userLogged?.isOwnerOfAnyBudget || false,
  userLoggedIsReviewer: state => state.userLogged?.isReviewer || false,
  filters: state => state.filters,
  getDeletedUsersFlag: state => state.getDeletedUsersFlag,
  userLocale: state => state.user.locale || false,
  // TODO: This affects roles
  userRoles: () => ['ROLE_BOOKKEEPER', 'ROLE_REGULAR'],
  currentPage: state => state.currentPage,
  lastPage: state => state.lastPage,
  totalItems: state => state.totalItems,
  isCallingUsers: state => state.isCallingUsers,
  userBudgets: state => state.userBudgets,
  userBudgetsCurrentPage: state => state.userBudgetsCurrentPage,
  userBudgetsLastPage: state => state.userBudgetsLastPage,
  userBudgetsTotalItems: state => state.userBudgetsTotalItems,
  isCallingUserBudgets: state => state.isCallingUserBudgets,
  errors: state => state.errors,
  adminRoles: () => ['ROLE_ADMIN', 'ROLE_ADMIN_OWNER', 'ROLE_ACCOUNT_HOLDER'],
  commercialRoles: () => ['ROLE_COMMERCIAL'],
  superAdminRoles: () => ['ROLE_SUPER_ADMIN'],
  accountingRoles: () => ['ROLE_BOOKKEEPER'],
  normalUserRoles: () => ['ROLE_REGULAR'],
  superBookRoles: () => ['ROLE_SUPER_BOOKKEEPER']
}
